import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';
import { CalendarMeetingLinkTypeKey } from '@/modules/calendarmeetinglink/enums/CalendarMeetingLinkTypeKey';
import { LocaleType } from '@/modules/user/constants/LocaleType';
import { CalendarMeetingLinkType } from '@/modules/calendarmeetinglink/enums/CalendarMeetingLinkType';

export class CalendarMeetingLink extends BaseEntityModel {
  id?: number;

  userId?: number;

  companyId?: number;

  type?: string;

  englishUrl?: string;

  frenchUrl?: string;

  englishEventTypeUuid?: string;
  frenchEventTypeUuid?: string;

  isHeadless?: boolean;

  constructor(model: Partial<CalendarMeetingLink> = {}) {
    super(model);

    this.id = model.id;
    this.userId = model.userId;
    this.companyId = model.companyId;
    this.type = model.type;
    this.englishUrl = model.englishUrl;
    this.frenchUrl = model.frenchUrl;
    this.englishEventTypeUuid = model.englishEventTypeUuid;
    this.frenchEventTypeUuid = model.frenchEventTypeUuid;
    this.isHeadless = model.isHeadless;
  }

  get isWillNotarizationMeetingLink(): boolean {
    return this.type === CalendarMeetingLinkTypeKey.WILL_NOTARIZATION;
  }

  get isProtectionMandateNotarizationMeetingLink(): boolean {
    return this.type === CalendarMeetingLinkTypeKey.PROTECTION_MANDATE_NOTARIZATION;
  }

  getLinkByLocale(locale: string = LocaleType.ENGLISH): string | undefined {
    if (locale === LocaleType.FRENCH) {
      return this.frenchUrl ?? this.englishUrl;
    }

    return this.englishUrl;
  }

  get linkType(): CalendarMeetingLinkType | undefined {
    return CalendarMeetingLinkType.getByKey(this.type as string);
  }
}
